import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40c1ae3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-pptist-dialog" }
const _hoisted_2 = { class: "configs" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "导出范围：", -1))
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = ["data-range"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 提示：.pptist 是本应用的特有文件后缀，支持将该类型的文件导入回应用中。 ", -1))
const _hoisted_8 = { class: "btns" }

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'

import {
  Button,
  Slider,
  Radio,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExportSpecificFile',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { Group: RadioGroup, Button: RadioButton } = Radio



const { slides, currentSlide } = storeToRefs(useSlidesStore())

const { exportSpecificFile } = useExport()

const rangeType = ref<'all' | 'current' | 'custom'>('all')
const range = ref<[number, number]>([1, slides.value.length])

const selectedSlides = computed(() => {
  if (rangeType.value === 'all') return slides.value
  if (rangeType.value === 'current') return [currentSlide.value]
  return slides.value.filter((item, index) => {
    const [min, max] = range.value
    return index >= min - 1 && index <= max - 1
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(RadioGroup), {
          class: "config-item",
          value: rangeType.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rangeType).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RadioButton), {
              style: {"width":"33.33%"},
              value: "all"
            }, {
              default: _withCtx(() => [
                _createTextVNode("全部")
              ]),
              _: 1
            }),
            _createVNode(_unref(RadioButton), {
              style: {"width":"33.33%"},
              value: "current"
            }, {
              default: _withCtx(() => [
                _createTextVNode("当前页")
              ]),
              _: 1
            }),
            _createVNode(_unref(RadioButton), {
              style: {"width":"33.33%"},
              value: "custom"
            }, {
              default: _withCtx(() => [
                _createTextVNode("自定义")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (rangeType.value === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "title",
              "data-range": `（${range.value[0]} ~ ${range.value[1]}）`
            }, "自定义范围：", 8, _hoisted_6),
            _createVNode(_unref(Slider), {
              class: "config-item",
              range: "",
              min: 1,
              max: _unref(slides).length,
              step: 1,
              value: range.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((range).value = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(Button), {
        class: "btn export",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(exportSpecificFile)(_unref(selectedSlides))))
      }, {
        default: _withCtx(() => [
          _createTextVNode("导出 .pptist 文件")
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "btn close",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})